import React from "react";
import Slider from "react-slick";
import '../scss/components/_responsive-slider.scss'

const defaultSettings = {
  dots: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  initialSlide: 0,

  responsive: [
    {
      breakpoint: 1150,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2
      }
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};

const ResponsiveSlider =(props) => (
    
    <div>
    <Slider {...props.settings || defaultSettings}>
    {props.elements.map((element) => {
            return(   
              <div style={{height:"100%"}}>{element}</div>
            )
        })
        }                                                 
    </Slider>
  </div>
);
export default ResponsiveSlider;
